import gpxParser from '../node_modules/gpxparser/src/GPXParser.js';

const parseGpx = gpxString => {
  let parser = new gpxParser();
  parser.parse(gpxString);
  return parser;
};

export { parseGpx };
